import { IState } from '../store';
import { TAnalyticsData } from '../types';

export function getAnalyticsData(state: IState): TAnalyticsData {
  const {
    offerData: { offer, agent, user, kp },
  } = state;

  return {
    offer,
    agent,
    user,
    village: kp,
  };
}
